/* eslint-disable jsx-a11y/alt-text */
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Mousewheel } from "swiper/modules";
import Download from "../components/icons/download";
import Logo from "../components/icons/logo";
import Copy from "../components/icons/copy";
import { mousewheel } from "../App";

const SHOW_COPY_TEXT_TIME = 500;
const COLOR_CODE = "#3d31ff";

const Section9 = ({ onSlideChange }) => {
  const [isCopyComplete, setIsCopyComplete] = useState(false);

  const handleCopyColor = () => {
    setIsCopyComplete(true);

    const textarea = document.createElement("textarea");
    textarea.value = COLOR_CODE;
    document.body.appendChild(textarea);

    textarea.focus();
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);

    setTimeout(() => {
      setIsCopyComplete(false);
    }, SHOW_COPY_TEXT_TIME);
  };

  return (
    <Swiper
      className="introduce"
      direction="vertical"
      slidesPerView="auto"
      mousewheel={mousewheel}
      nested
      freeMode
      preventInteractionOnTransition
      updateOnWindowResize
      modules={[FreeMode, Mousewheel]}
      onSlideChange={onSlideChange}
    >
      <SwiperSlide style={{ height: "fit-content" }}>
        <div className="asset_box">
          <div className="container asset_container">
            <div className="text_wrap">
              <p className="asset_title animated_text">Download Brand Assets</p>
              <p className="asset_desc animated_text delay">
                LocknLock offers comprehensive
                <br />
                resources and guidelines to
                <br />
                ensure our brand assets are used
                <br />
                consistently pantoand effectively.
              </p>
              <a
                className="download_all"
                href="https://www.locknlock.com/eng/image/common/about/brand/Brand_All.zip"
                download="brand_all.zip"
              >
                Download All
              </a>
            </div>
            <div className="assets">
              <div className="asset">
                <p className="label">Brand Logo</p>
                <label className="brand_toggle">
                  <input type="checkbox" className="toggle_check" />
                  <div className="toggle_item">Light</div>
                  <div className="toggle_item">Dark</div>
                </label>
                <Logo />
                <a
                  className="download"
                  href="https://www.locknlock.com/eng/image/common/about/brand/Brand_Logo.zip"
                  download="brand_logo.zip"
                >
                  <Download stroke="#508cff" />
                  Download
                </a>
              </div>
              <div className="asset">
                <p className="label">Brand Slogan</p>
                <p className="slogan">Lockin’ Your Moment</p>
                <a
                  className="download"
                  href="https://www.locknlock.com/eng/image/common/about/brand/Brand_Slogan.zip"
                  download="brand_slogan.zip"
                >
                  <Download stroke="#508cff" />
                  Download
                </a>
              </div>
              <div className="asset bg_image">
                <picture className="brand_bg">
                  <source
                    srcSet="//www.locknlock.com/eng/image/common/about/brand/img_asset_brand_bg_pc.png"
                    media="(min-width: 768px)"
                  />
                  <img src="//www.locknlock.com/eng/image/common/about/brand/img_asset_brand_bg_mob.png" />
                </picture>
                <div className="content_wrap">
                  <p className="label">Brand Images</p>
                  <a
                    className="download"
                    href="https://www.locknlock.com/eng/image/common/about/brand/Brand_Image.zip"
                    download="brand_images.zip"
                  >
                    <Download stroke="#fff" />
                    Download
                  </a>
                </div>
              </div>
              <div className="asset bg_blue">
                <p className="label">
                  Brand Colors
                  <button className="color_copy">
                    <Copy />
                    <p className="mob_text" onClick={handleCopyColor}>
                      Copy{isCopyComplete ? " Complete" : ""}
                    </p>
                    <div className="copy_cover_wrap" onClick={handleCopyColor}>
                      <p className="text">
                        Copy{isCopyComplete ? " Complete" : ""}
                      </p>
                    </div>
                  </button>
                </p>
                <p className="info">
                  {COLOR_CODE}
                  <br />
                  R:61 G:49 B:255
                  <br />
                  C:96 M:64 Y:0 K:0
                  <br />
                  Pantone 2935C
                </p>
                <a
                  className="download"
                  href="https://www.locknlock.com/eng/image/common/about/brand/Brand_Color.zip"
                  download="brand_colors.zip"
                >
                  <Download stroke="#fff" />
                  Download
                </a>
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
  );
};

export default Section9;
